module.exports = __webpack_public_path__ + "img/flow-waiting.820e2c6c.svg";